import { createAsyncThunk } from "@reduxjs/toolkit";
import { get_detail } from "../../api/getMovie.js";
import { createSlice } from "@reduxjs/toolkit";

export const fetchMovieData = createAsyncThunk(
    'movieData/fetchMovieData',
    async (movieId, {rejectWithValue}) => {
        try {
            const movieData = await get_detail(movieId);
            return movieData;
        }catch(error){
            return rejectWithValue(error.message)
        }
    }
);


const MovieDataSlice = createSlice({
    name: "movieData",
    initialState: {
        movies: [],
        loading: false,
        error: false
    }, 
    reducers: {
    },
    extraReducers: {
        [fetchMovieData.pending]:  (state, action) => {
            //const {movieId} = action.meta.arg;
            state.loading = true;
            state.error = false;
        },
        [fetchMovieData.fulfilled]: (state, action) => {
            //const {movieId, movieData} = action.payload;
            //state.movieDatas[movieId] = movieData;
            state.movies = action.payload;
            state.loading = false;
            state.error = false;
        },
        [fetchMovieData.rejected]: (state,action) => {
            //const {movieId} = action.meta.arg;
            state.loading = false;
            state.error = true;
        }
    }
});


export default MovieDataSlice.reducer;
